import React from 'react';
import { styled } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-premium';

import DateField from 'app/main/components/fields/DateField';

import type { EditInputCellParams } from '../DetailsSectionTableInputCells';

type DateEditInputCellParams = EditInputCellParams<string>;

const DateEditInputCell = styled((props: DateEditInputCellParams) => {
	const apiRef = useGridApiContext();

	// const inputRef = React.useRef<HTMLInputElement>();

	function handleChange(_name, newValue) {
		apiRef.current.setEditCellValue({ id: props.id, field: props.field, value: newValue, debounceMs: 200 });
	}

	// React.useEffect(() => {
	// 	if (props.hasFocus) inputRef.current?.focus();
	// }, [props.hasFocus]);

	return (
		<DateField
			className={props.className}
			value={props.value}
			name={props.field}
			isEdit
			sendChange={handleChange}
		/>
	);
})(({ theme }) => ({
	height: '100%',
	'& > .MuiInputBase-root > .MuiInputBase-input': {
		paddingTop: 8,
		paddingBottom: 8,
		paddingLeft: 8
	}
}));

export default React.memo(DateEditInputCell);
